import { Field } from 'formik';
import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label } from 'reactstrap';

const FieldItem = (props) => {
   return (
      <FormGroup>
         <Label
            className='d-block'
         >

            { props.label }
            <span className='float-right'>
               {props.children}
            </span>
            <Field
               {
                  ...props
               }
            />
         </Label>
      </FormGroup>
   );
};

FieldItem.propTypes = {
   label: PropTypes.string.isRequired,
   name: PropTypes.string.isRequired,
   component: PropTypes.func.isRequired,
   options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
   })),
};

FieldItem.defaultProps = {
   options: undefined,
};


export default FieldItem;
